import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}
export function Section({
  children,
  className = '',
  id
}: SectionProps) {
  return <section id={id} className={`py-16 md:py-24 ${className}`} data-id="element-412">
      {children}
    </section>;
}